import { Component } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import PageTitle from '../../common/page-title/index';
import withTabs from '../../common/withTabs';
import RewardsStatement from './rewards-statement';
import { getPersonalPointsActivity } from '../../../actions/points-statement';

const PERSONAL = 'personal';

class PointsActivity extends Component {
  constructor(props) {
    super(props);
    this.outlet = this.props.match.params.outlet;
  }

  render() {
    const {
      tab, handleTabSelect, staffList, personalList, staffListPaging, personalListPaging, ...rest
    } = this.props;

    return (
      <Container fluid className="points-activity-menu">
        <PageTitle>Points Activity</PageTitle>
        <Tabs activeKey={tab} onSelect={handleTabSelect} id="points-activity-tabs">
          <Tab eventKey={PERSONAL} title="Personal Rewards Statement">
            <RewardsStatement
              getListAction={getPersonalPointsActivity}
              list={personalList}
              pagination={personalListPaging}
              outlet={this.outlet}
              {...rest}
            />
          </Tab>
        </Tabs>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  staffList: state.points_statement.staffList,
  personalList: state.points_statement.personalList,
  staffListPaging: state.points_statement.staffListPaging,
  personalListPaging: state.points_statement.personalListPaging,
  fetching: state.points_statement.fetching,
  fetched: state.points_statement.fetched
});

export default connect(mapStateToProps)(withTabs(PointsActivity, PERSONAL));
